import { Box, Flex, type BoxProps } from '@chakra-ui/react';
import { keyframes } from "@/utils/keyframes"
import React from 'react'


interface LoadingProps extends BoxProps {}


const scale = () =>
  keyframes({
    '0%, 40%, 100%': {
      transform: 'scaleY(0.4)'
    },
    '20%': {
      transform: 'scaleY(1.0)',
    }
  })

const LoadingItem = (props: { delay: string }) => (
  <Box
    bgColor='currentcolor'
    h='1em'
    width={`${3/35}em`}
    mr={`${6/35}em`}
    animation={`1.2s ${props.delay} infinite ease-in-out ${scale()}`}
  />
)


const Component = React.forwardRef((props: LoadingProps, ref: React.Ref<any>) => {
  return (
    <Flex
      ref={ref}
      color='text.normal'
      {...props}
      >
      <LoadingItem delay="-1.1s" />
      <LoadingItem delay="-1s" />
      <LoadingItem delay="-0.9s" />
      <LoadingItem delay="-0.8s" />
    </Flex>
  )
})

export {
  Component as Loading,
  type LoadingProps,
}
